import React, { useRef } from "react";
import { useSvgPlayback } from "./motion";

function Glyph({ className, viewBox, children }) {
  const ref = useRef(null);
  useSvgPlayback(ref);
  return (
    <svg
      ref={ref}
      className={className}
      viewBox={viewBox}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      aria-hidden="true"
      focusable="false"
    >
      {children}
    </svg>
  );
}

const ROUTE = "M6 50C22 50 20 31 35 32S52 26 62 24";
const LINK = "M33 19C44 19 40 37 51 37";

// One drawing per facet: the destination, the work in motion, and the boundaries you set.
export function FacetGlyph({ index }) {
  if (index === 0)
    return (
      <Glyph className="bm-glyph bm-facet-glyph" viewBox="0 0 88 56">
        <circle cx="62" cy="24" r="15" strokeOpacity=".22" />
        <circle cx="62" cy="24" r="8.5" strokeOpacity=".45" />
        <circle cx="62" cy="24" r="2.6" fill="currentColor" stroke="none" />
        <path d={ROUTE} strokeDasharray="1.5 4.5" />
        <circle r="2.8" fill="currentColor" stroke="none">
          <animateMotion
            dur="3.4s"
            repeatCount="indefinite"
            path={ROUTE}
            keyPoints="0;1;1"
            keyTimes="0;.7;1"
            calcMode="linear"
          />
        </circle>
        <circle cx="62" cy="24" r="3">
          <animate attributeName="r" values="3;3;19" keyTimes="0;.7;1" dur="3.4s" repeatCount="indefinite" />
          <animate
            attributeName="stroke-opacity"
            values="0;0;.8;0"
            keyTimes="0;.69;.7;1"
            dur="3.4s"
            repeatCount="indefinite"
          />
        </circle>
      </Glyph>
    );
  if (index === 1)
    return (
      <Glyph className="bm-glyph bm-facet-glyph" viewBox="0 0 88 56">
        <rect x="3" y="8" width="30" height="22" rx="2.5" />
        <path d="M3 13h30" strokeOpacity=".4" />
        <rect x="51" y="26" width="34" height="24" rx="2.5" />
        <path d="M51 31h34" strokeOpacity=".4" />
        {[
          [8, 19, 22, "0s"],
          [8, 24, 16, ".6s"],
          [56, 37, 26, "1.1s"],
          [56, 43, 18, "1.7s"],
        ].map(([x, y, len, begin]) => (
          <path key={y} d={`M${x} ${y}h${len}`} strokeOpacity=".55" strokeDasharray={`${len} ${len}`}>
            <animate
              attributeName="stroke-dashoffset"
              values={`${len};0;0;${len}`}
              keyTimes="0;.35;.85;1"
              dur="2.8s"
              begin={begin}
              repeatCount="indefinite"
            />
          </path>
        ))}
        <path d={LINK} strokeDasharray="1.5 3.5" strokeOpacity=".7" />
        <circle r="2.4" fill="currentColor" stroke="none">
          <animateMotion dur="1.8s" repeatCount="indefinite" path={LINK} />
        </circle>
        <circle r="2.4" fill="currentColor" stroke="none" opacity=".45">
          <animateMotion dur="1.8s" begin=".9s" repeatCount="indefinite" path={LINK} keyPoints="1;0" keyTimes="0;1" calcMode="linear" />
        </circle>
      </Glyph>
    );
  return (
    <Glyph className="bm-glyph bm-facet-glyph" viewBox="0 0 88 56">
      <path d="M6 34h76" strokeOpacity=".25" />
      <rect x="20" y="30" width="48" height="8" rx="4" fill="currentColor" fillOpacity=".07" stroke="none" />
      <path d="M24 22v24M20 22h4M20 46h4M64 22v24M68 22h-4M68 46h-4" />
      <circle cy="34" r="5.2" fill="currentColor" stroke="none">
        <animate
          attributeName="cx"
          values="32;56;42;56;32"
          keyTimes="0;.3;.55;.8;1"
          calcMode="spline"
          keySplines=".6 0 .2 1;.6 0 .2 1;.6 0 .2 1;.6 0 .2 1"
          dur="5s"
          repeatCount="indefinite"
        />
      </circle>
      <path d="M44 8l4 6h-8z" fill="currentColor" stroke="none" opacity=".75" />
      <path d="M44 14v6" strokeOpacity=".45" strokeDasharray="1.5 2.5" />
    </Glyph>
  );
}
